export default "__VITE_ASSET__BDW3iDVc__"